document.addEventListener('click', function (e) {

  /* =========================
     FAQ TOGGLE
  ========================== */

  const question = e.target.closest('.faq-question');
  if (question) {

    const item = question.closest('.faq-item');
    const answer = item.querySelector('.faq-answer');
    const icon = question.querySelector('.faq-icon');

    // Close other items
    document.querySelectorAll('.faq-item').forEach(other => {
      if (other !== item) {
        other.classList.remove('active');
        const otherAnswer = other.querySelector('.faq-answer');
        const otherIcon = other.querySelector('.faq-icon');

        if (otherAnswer) otherAnswer.style.maxHeight = null;
        if (otherIcon) otherIcon.textContent = '+';
      }
    });

    // Toggle current item
    item.classList.toggle('active');

    if (item.classList.contains('active')) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
      icon.textContent = '−';
    } else {
      answer.style.maxHeight = null;
      icon.textContent = '+';
    }
  }


  /* =========================
     VIEW MORE
  ========================== */

  const viewMore = e.target.closest('#faqViewMore');
  if (viewMore) {

    const faqs = document.querySelectorAll('.faq-item');
    const STEP = 5;
    const hiddenFaqs = document.querySelectorAll('.faq-item.faq-hidden');

    if (hiddenFaqs.length > 0) {

      let shown = 0;
      faqs.forEach(faq => {
        if (faq.classList.contains('faq-hidden') && shown < STEP) {
          faq.classList.remove('faq-hidden');
          shown++;
        }
      });

      if (document.querySelectorAll('.faq-item.faq-hidden').length === 0) {
        viewMore.textContent = 'View Less';
      }

    } else {

      faqs.forEach((faq, index) => {
        if (index >= STEP) faq.classList.add('faq-hidden');
      });

      viewMore.textContent = 'View More';
    }
  }

});